interface MediaItem {
  title: string;
  tag: string;
  image: string;
  imageAlt: string;
  duration: string;
  desc: string;
}

const items: MediaItem[] = [
  {
    title: '《暗夜追踪》官方预告',
    tag: '即将上线',
    image: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20film%20trailer%20thumbnail%20with%20play%20button%20overlay%20style%2C%20mysterious%20night%20scene%20with%20detective%2C%20warm%20amber%20accent%20lighting%2C%20cinematic%20widescreen%20composition%2C%20professional%20video%20thumbnail%20quality%2C%20film%20grain&width=640&height=360&seq=media-01&orientation=landscape',
    imageAlt: '暗夜追踪官方预告片',
    duration: '2:35',
    desc: '悬疑巨制首曝预告，扣人心弦的剧情片段抢先看',
  },
  {
    title: '《长安风云录》幕后特辑',
    tag: '独家花絮',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20chinese%20historical%20drama%20production%2C%20costume%20and%20set%20design%20showcase%2C%20warm%20studio%20lighting%2C%20cinematic%20documentary%20style%2C%20professional%20production%20quality%2C%20rich%20textures&width=640&height=360&seq=media-02&orientation=landscape',
    imageAlt: '长安风云录幕后特辑',
    duration: '5:12',
    desc: '探班古装大剧制作现场，揭秘精良服化道背后的故事',
  },
  {
    title: '《星际迷航》视觉解析',
    tag: '深度解读',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20visual%20effects%20breakdown%20thumbnail%2C%20spaceship%20design%20and%20concept%20art%2C%20warm%20orange%20and%20gold%20accent%20colors%2C%20cinematic%20composition%2C%20professional%20production%20quality%2C%20creative%20studio&width=640&height=360&seq=media-03&orientation=landscape',
    imageAlt: '星际迷航视觉解析',
    duration: '8:40',
    desc: '专业解析年度科幻巨制的视觉特效制作全流程',
  },
  {
    title: '《小镇故事》导演访谈',
    tag: '主创专访',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20interview%20scene%20in%20warm%20cozy%20studio%20setting%2C%20cinematic%20lighting%20setup%2C%20professional%20video%20production%20quality%2C%20soft%20warm%20tones%2C%20intimate%20atmosphere%2C%20documentary%20style&width=640&height=360&seq=media-04&orientation=landscape',
    imageAlt: '小镇故事导演访谈',
    duration: '12:15',
    desc: '导演亲述创作心路，解读影片背后的温情与思考',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩预告</h2>
            <p className="text-sm text-foreground-600 mt-1">预告片 · 幕后花絮 · 独家专访</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {items.map((item, i) => (
              <a
                key={i}
                href="#media"
                className="group cursor-pointer"
              >
                <div className="relative aspect-video rounded-xl overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-background-50/30 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 rounded bg-background-50/80 text-foreground-950 text-xs font-medium whitespace-nowrap">
                      {item.duration}
                    </span>
                  </div>
                </div>
                <h3 className="font-medium text-foreground-950 mt-3 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1 line-clamp-1">{item.desc}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}